import { render, staticRenderFns } from "./FieldInfoTypeC.vue?vue&type=template&id=c1933342&scoped=true"
import script from "./FieldInfoTypeC.vue?vue&type=script&lang=js"
export * from "./FieldInfoTypeC.vue?vue&type=script&lang=js"
import style0 from "./FieldInfoTypeC.vue?vue&type=style&index=0&id=c1933342&prod&scoped=true&lang=scss"
import style1 from "./FieldInfoTypeC.vue?vue&type=style&index=1&id=c1933342&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1933342",
  null
  
)

export default component.exports